<template>
	<div class="container-pagamento">
		<div class="card-container">
			<div class="payment-values">
				<BoxSmall
					:linear-gradient="{
						bgInital: '#0db2de',
						bgFinal: '#005bea',
					}"
					background-color="#fb8500"
					title="Valor"
					:subtitle="transformToBrl(payment.amount / 100)"
					:icon="{
						type: 'dollar-sign',
						size: '35px',
						color: '#000000',
					}"
				/>
				<BoxSmall
					background-color="#7209b7"
					title="Pagamento"
					:subtitle="(payment.paymentType = 'credit') ? 'Crédito' : 'Débito'"
					:linear-gradient="{
						bgFinal: '#f93a5a',
						bgInital: '#f7778c',
					}"
					:icon="{
						type: 'credit-card',
						size: '35px',
						color: '#000000',
					}"
				/>
				<BoxSmall
					background-color="#f94144"
					title="Parcelas"
					:subtitle="payment.numberInstallments ? payment.numberInstallments + 'x' : '0'"
					:linear-gradient="{
						bgFinal: '#029666 ',
						bgInital: '#48d6a8 ',
					}"
					:icon="{
						type: 'scissors',
						size: '35px',
						color: '#000000',
					}"
				/>
				<BoxSmall
					background-color="#43aa8b"
					title="Status"
					:subtitle="payment.status"
					:linear-gradient="{
						bgFinal: '#f76a2d',
						bgInital: '#efa65f',
					}"
					:icon="{
						type: getTimelineIcon(payment.status).icon,
						size: '35px',
						color: '#000000',
					}"
				/>
			</div>
		</div>
		<div class="container-details">
			<div class="left-content">
				<div class="details-client">
					<div class="title-payment">Cliente</div>
					<div class="list-details_payments">
						<div v-if="validPaymentManual(payment.gatewayPaymentId)" class="list-row">
							<p>
								<strong class="label-color">Titular do Cartão:</strong> {{ payment.customerName }}
							</p>
						</div>
						<div v-else class="list-row">
							<p><strong class="label-color">Razão Social:</strong> {{ payment.customerName }}</p>
						</div>
						<div class="list-row">
							<p><strong class="label-color">Id:</strong> {{ payment.customerId }}</p>
						</div>
						<div class="list-row">
							<p><strong class="label-color">Email:</strong> {{ payment.customerEmail }}</p>
						</div>
						<div class="list-row">
							<p><strong class="label-color">Endereço:</strong> {{ payment.customerAddress }}</p>
						</div>
						<div class="list-row">
							<p><strong class="label-color">Ip:</strong> {{ payment.ipAddress }}</p>
						</div>
					</div>
				</div>
				<div class="details-payment">
					<div class="title-payment">Dados de pagamento</div>
					<div class="list-details_payments">
						<div class="list-row">
							<p><strong class="label-color">Id Pedido:</strong> #{{ payment.orderId }}</p>
						</div>
						<div class="list-row">
							<p>
								<strong class="label-color">Antifraude:</strong>
								{{ (payment.antifraud === 1 ? 'Bloqueado' : null) || 'Liberado' }}
							</p>
						</div>
						<div class="list-row">
							<p>
								<strong class="label-color">Id Pagamento:</strong> #{{ payment.gatewayPaymentId }}
							</p>
						</div>
						<!--          <div class="list-row">
              <p><strong class="label-color">NSU:</strong> 682414</p>
            </div> -->
						<div class="list-row">
							<p>
								<strong class="label-color">Data:</strong>
								{{ dateTimeToBrasilWithTimezone(payment.created_at || payment.timestamp) }}
							</p>
						</div>
					</div>
				</div>
				<TimelineObs
					v-if="observacao.length > 0"
					margin-bottom="30px"
					margin-top="30px"
					title="Observações"
					width="100%"
					:data="observacao"
				/>
			</div>
			<div class="container-right">
				<div class="card-details">
					<div class="title-payment">Histórico</div>
					<div class="historico-payment">
						<Timeline :data="payment.paymentHistory" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BoxSmall from '../../layout/components/box/rounded-small';
import Timeline from '../../layout/components/timeline/simples';
import * as ecAxios from '../../util/ecAxios';
import global from '../../mixins/global';
import TimelineObs from '../../layout/components/timeline/default';

export default {
	components: {
		BoxSmall,
		Timeline,
		TimelineObs,
	},
	mixins: [global],
	data() {
		return {
			payment: [],
			observacao: [],
		};
	},
	activated() {
		this.getPaymentDetails();
		this.getObservation();
	},
	methods: {
		async getObservation() {
			const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_SHOW_OBSERVATION}/1/${this.$route.params.id}`;
			const response = await ecAxios.connection().get(url);
			if (response.data.error === 0) {
				this.observacao = response.data.observacao;
			} else {
				this.$buefy.notification.open({
					message: response.data.message,
					type: 'is-danger',
				});
			}
		},
		validPaymentManual(gatewayId) {
			if (gatewayId) {
				const searchKey = gatewayId.search('PM');
				if (searchKey !== -1) {
					return true;
				}
			}
			return false;
		},
		getTimelineIcon(situacao) {
			switch (situacao) {
				case 'DENIED':
					return {
						icon: 'x',
						color: 'rgb(249, 58, 90)',
						backgroundColor: 'rgb(249, 58, 90, 0.08)',
					};
				case 'DENY':
					return {
						icon: 'x',
						color: 'rgb(249, 58, 90)',
						backgroundColor: 'rgb(249, 58, 90, 0.08)',
					};
				case 'CONFIRMED':
					return { icon: 'check', color: '#00751a', backgroundColor: 'rgb(0, 117, 26, 0.08)' };
				case 'AUTHORIZED':
					return {
						icon: 'shield',
						color: 'rgb(0, 91, 234)',
						backgroundColor: 'rgb(0, 91, 234, 0.08)',
					};
				case 'NOT APPROVED':
					return {
						icon: 'x',
						color: 'rgb(249, 58, 90)',
						backgroundColor: 'rgb(249, 58, 90, 0.08)',
					};
				case 'NOT VERIFIED':
					return {
						icon: 'alert-triangle',
						color: '#FFF',
						backgroundColor: 'rgb(0, 117, 26, 0.08)',
					};
				default:
					return { icon: 'check', color: '#FFF ', backgroundColor: 'rgb(0, 117, 26, 0.08)' };
			}
		},
		async getPaymentDetails() {
			const { gateway, id } = this.$route.params;
			if (!gateway) return;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}/pedidopgtocartao/detailed/${gateway}/${id}`;
				const request = await ecAxios.connection().get(url);
				const { payment } = request.data;
				if (!payment.error) {
					if (payment.paymentHistory) {
						const searchedIndex = this.searchForDuplicatesByIndex(
							{ index: 'status', data: 'AUTHORIZED' },
							payment.paymentHistory
						);

						if (searchedIndex.length >= 2) {
							payment.paymentHistory.splice(searchedIndex[1], 1);
						}
					}
					this.payment = payment;
				} else {
					throw new Error(payment.message || 'Ocorreu um erro ao atualizar');
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao carregar os dados.',
					type: 'is-danger',
				});
			}
		},
	},
};
</script>

<style scoped>
.historico-payment {
	margin-top: 20px;
}
.container-right {
	width: 49%;
}
.card-details {
	width: 100%;
	padding: 20px;
	margin-bottom: 30px;
	border-radius: 5px;
	background-color: #fff;
	box-shadow: rgb(218, 222, 232) -8px 12px 18px 0px;
}
.label-color {
	color: #636363;
}
.container-details {
	display: flex;
	width: 100%;
	justify-content: space-between;
}
.title-bold {
	font-weight: bold;
}
.title-payment {
	font-weight: bold;
	font-size: 14px;
}
.list-details_payments {
	margin-top: 20px;
	display: flex;
	flex-direction: column;
}
.list-row {
	display: flex;
	flex-direction: row;
	font-size: 12px;
	margin-bottom: 15px;
}
.left-content {
	width: 49%;
}
.details-payment {
	padding: 20px;
	width: 100%;
	border-radius: 5px;
	background-color: #fff;
	box-shadow: rgb(218, 222, 232) -8px 12px 18px 0px;
}
.details-client {
	padding: 20px;
	width: 100%;
	border-radius: 5px;
	background-color: #fff;
	box-shadow: rgb(218, 222, 232) -8px 12px 18px 0px;
	margin-bottom: 30px;
}
.payment-values {
	width: 100%;
	display: flex;
	justify-content: space-between;
}
.card-container {
	width: 100%;
	margin-bottom: 30px;
}
.container-pagamento {
	width: 100%;
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}
</style>

